import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Cascader, Tooltip } from "antd";
import { removePrefixPath } from "../../utils/stuff";
import { Utils } from "@react-awesome-query-builder/ui";
var useOnPropsChanged = Utils.ReactUtils.useOnPropsChanged;
var getFieldParts = Utils.ConfigUtils.getFieldParts;

// see type FieldItemSearchableKeys
var mapFieldItemToOptionKeys = {
  key: "_value2",
  path: "path",
  label: "_label",
  altLabel: "altLabel",
  tooltip: "tooltip",
  grouplabel: "grouplabel",
  fullLabel: "fullLabel"
};
var searchInPath = false; // true - search in all path, false - only in last path item
var FieldCascader = /*#__PURE__*/function (_Component) {
  _inherits(FieldCascader, _Component);
  var _super = _createSuper(FieldCascader);
  function FieldCascader(props) {
    var _this;
    _classCallCheck(this, FieldCascader);
    _this = _super.call(this, props);
    _this.onChange = function (keys) {
      var parentField = _this.props.parentField;
      var dotNotationToPath = function dotNotationToPath(str) {
        return str.split(".");
      };
      var parentPath = parentField ? dotNotationToPath(parentField) : [];
      _this.props.setField([].concat(_toConsumableArray(parentPath), _toConsumableArray(keys)));
    };
    _this.filterOption = function (input, path) {
      var config = _this.props.config;
      var keysForFilter = config.settings.fieldItemKeysForSearch.map(function (k) {
        return mapFieldItemToOptionKeys[k];
      });
      var filterOneOption = function filterOneOption(option) {
        var valueForFilter = keysForFilter.map(function (k) {
          return typeof option[k] == "string" ? option[k] : "";
        }).join("\0");
        var matches = valueForFilter.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        return matches;
      };
      return searchInPath ? path.some(filterOneOption) : filterOneOption(path[path.length - 1]);
    };
    useOnPropsChanged(_assertThisInitialized(_this));
    _this.onPropsChanged(props);
    return _this;
  }
  _createClass(FieldCascader, [{
    key: "onPropsChanged",
    value: function onPropsChanged(nextProps) {
      var items = nextProps.items;
      this.items = this.getItems(items);
    }
  }, {
    key: "getItems",
    value: function getItems(items) {
      var _this2 = this;
      return items.map(function (item) {
        var items = item.items,
          matchesType = item.matchesType,
          label = item.label,
          key = item.key,
          path = item.path;
        if (items) {
          return _objectSpread(_objectSpread({}, item), {}, {
            key: path,
            _value2: key,
            items: _this2.getItems(items),
            label: matchesType ? /*#__PURE__*/React.createElement("b", null, label) : label,
            _label: label
          });
        } else {
          return _objectSpread(_objectSpread({}, item), {}, {
            key: path,
            _value2: key,
            label: matchesType ? /*#__PURE__*/React.createElement("b", null, label) : label,
            _label: label
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        customProps = _this$props.customProps,
        items = _this$props.items,
        placeholder = _this$props.placeholder,
        errorText = _this$props.errorText,
        selectedPath = _this$props.selectedPath,
        selectedLabel = _this$props.selectedLabel,
        selectedOpts = _this$props.selectedOpts,
        selectedAltLabel = _this$props.selectedAltLabel,
        selectedFullLabel = _this$props.selectedFullLabel,
        readonly = _this$props.readonly,
        selectedField = _this$props.selectedField,
        parentField = _this$props.parentField;
      var customProps2 = _objectSpread({}, customProps);
      if (customProps2.showSearch) {
        customProps2.showSearch = {
          filter: this.filterOption
        };
      }
      var fieldSeparator = config.settings.fieldSeparator;
      var parentFieldPath = getFieldParts(parentField, config);
      var value = removePrefixPath(selectedPath, parentFieldPath);
      var res = /*#__PURE__*/React.createElement(Cascader, _extends({
        status: errorText && "error",
        fieldNames: {
          label: "label",
          value: "key",
          children: "items"
        },
        options: this.items,
        value: value,
        onChange: this.onChange,
        allowClear: false,
        placeholder: placeholder,
        size: config.settings.renderSize,
        disabled: readonly
      }, customProps2));
      var tooltipText = selectedOpts.tooltip || selectedAltLabel;
      if (tooltipText == selectedLabel) tooltipText = null;
      if (tooltipText) {
        res = /*#__PURE__*/React.createElement(Tooltip, {
          title: tooltipText
        }, res);
      }
      return res;
    }
  }]);
  return FieldCascader;
}(Component);
FieldCascader.propTypes = {
  config: PropTypes.object.isRequired,
  customProps: PropTypes.object,
  errorText: PropTypes.string,
  items: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  selectedKey: PropTypes.string,
  selectedKeys: PropTypes.array,
  selectedPath: PropTypes.array,
  selectedLabel: PropTypes.string,
  selectedAltLabel: PropTypes.string,
  selectedFullLabel: PropTypes.string,
  selectedOpts: PropTypes.object,
  readonly: PropTypes.bool,
  //actions
  setField: PropTypes.func.isRequired
};
export { FieldCascader as default };